document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll('.video-trigger');
  const dialog = document.getElementById('video-dialog');
  const iframe = document.getElementById('youtube-player');
  const closeBtn = document.getElementById('close-video');

  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const videoId = trigger.dataset.video;

      iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;

      dialog.showModal();
    });
  });

  function closeVideo() {
    dialog.close();

    // Remove src so video stops
    iframe.src = '';
  }

  closeBtn.addEventListener('click', closeVideo);

  // Optional: click backdrop to close
  dialog.addEventListener('click', (e) => {
    const rect = dialog.getBoundingClientRect();

    const insideDialog =
      e.clientX >= rect.left &&
      e.clientX <= rect.right &&
      e.clientY >= rect.top &&
      e.clientY <= rect.bottom;

    if (!insideDialog) {
      closeVideo();
    }
  });

  // Also clear if closed by Esc
  dialog.addEventListener('close', () => {
    iframe.src = '';
  });
});